// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": function componentCacheCachesGatsbyPluginOfflineAppShellJs() {
    return import("./../../.cache/caches/gatsby-plugin-offline/app-shell.js"
    /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */
    );
  },
  "component---src-pages-about-js": function componentSrcPagesAboutJs() {
    return import("./../../src/pages/about.js"
    /* webpackChunkName: "component---src-pages-about-js" */
    );
  },
  "component---src-pages-protected-portfolio-js": function componentSrcPagesProtectedPortfolioJs() {
    return import("./../../src/pages/protected-portfolio.js"
    /* webpackChunkName: "component---src-pages-protected-portfolio-js" */
    );
  },
  "component---src-templates-categories-list-template-js": function componentSrcTemplatesCategoriesListTemplateJs() {
    return import("./../../src/templates/categories-list-template.js"
    /* webpackChunkName: "component---src-templates-categories-list-template-js" */
    );
  },
  "component---src-templates-category-template-js": function componentSrcTemplatesCategoryTemplateJs() {
    return import("./../../src/templates/category-template.js"
    /* webpackChunkName: "component---src-templates-category-template-js" */
    );
  },
  "component---src-templates-headfootwrapper-template-js": function componentSrcTemplatesHeadfootwrapperTemplateJs() {
    return import("./../../src/templates/headfootwrapper-template.js"
    /* webpackChunkName: "component---src-templates-headfootwrapper-template-js" */
    );
  },
  "component---src-templates-index-template-js": function componentSrcTemplatesIndexTemplateJs() {
    return import("./../../src/templates/index-template.js"
    /* webpackChunkName: "component---src-templates-index-template-js" */
    );
  },
  "component---src-templates-not-found-template-js": function componentSrcTemplatesNotFoundTemplateJs() {
    return import("./../../src/templates/not-found-template.js"
    /* webpackChunkName: "component---src-templates-not-found-template-js" */
    );
  },
  "component---src-templates-page-template-js": function componentSrcTemplatesPageTemplateJs() {
    return import("./../../src/templates/page-template.js"
    /* webpackChunkName: "component---src-templates-page-template-js" */
    );
  },
  "component---src-templates-post-template-js": function componentSrcTemplatesPostTemplateJs() {
    return import("./../../src/templates/post-template.js"
    /* webpackChunkName: "component---src-templates-post-template-js" */
    );
  },
  "component---src-templates-tag-template-js": function componentSrcTemplatesTagTemplateJs() {
    return import("./../../src/templates/tag-template.js"
    /* webpackChunkName: "component---src-templates-tag-template-js" */
    );
  },
  "component---src-templates-tags-list-template-js": function componentSrcTemplatesTagsListTemplateJs() {
    return import("./../../src/templates/tags-list-template.js"
    /* webpackChunkName: "component---src-templates-tags-list-template-js" */
    );
  }
};